<template>
  <div>
    <Head title="Periode Pertanggungjawaban" />

    <h1 class="mb-8 text-2xl font-bold">Periode Pertanggungjawaban</h1>

    <div class="flex items-center justify-end mb-6">
      <Link v-if="can('write periode beasiswa')" class="btn-indigo" href="/accountability-periodes/create">
        <span><font-awesome-icon icon="fas fa-plus" class="mr-2" />Tambah</span>
      </Link>
    </div>

    <div class="overflow-x-auto bg-white rounded-md shadow">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="font-bold text-left">
            <th class="px-6 pt-6 pb-4">Jenis</th>
            <th class="px-6 pt-6 pb-4">Periode Laporan</th>
            <th class="px-6 pt-6 pb-4">Periode PJ</th>
            <th class="px-6 pt-6 pb-4">Nominal Beasiswa</th>
            <th class="px-6 pt-6 pb-4">Tahun Anggaran</th>
            <th v-if="can('write periode pertanggungjawaban')" class="px-6 pt-6 pb-4 border-b">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="periode in accountabilityPeriodes.data" :key="periode.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="p-4 border-t">
              {{ periode.jenis }}
            </td>
            <td class="p-4 border-t">
              {{ periode.periode_laporan }}
            </td>
            <td class="p-4 border-t">
              {{ periode.periode_pj }}
            </td>
            <td class="p-4 border-t">
              <ul v-if="periode.jenis === 'KCS'">
                <li>KCS: {{ formatCurrency(periode.nominal_kcs) }}</li>
              </ul>
              <ul v-else-if="periode.jenis === 'Juare'">
                <li>PTS Prestasi: {{ formatCurrency(periode.nominal_pts_prestasi) }}</li>
                <li>PTS PraSejahtera: {{ formatCurrency(periode.nominal_pts_non_prestasi) }}</li>
                <li>PTNL Prestasi: {{ formatCurrency(periode.nominal_ptnl_prestasi) }}</li>
                <li>PTNL PraSejahtera: {{ formatCurrency(periode.nominal_ptnl_non_prestasi) }}</li>
                <li>PTN & PTKL Prestasi: {{ formatCurrency(periode.nominal_ptn_prestasi) }}</li>
                <li>PTN & PTKL PraSejahtera: {{ formatCurrency(periode.nominal_ptn_non_prestasi) }}</li>
              </ul>
            </td>
            <td class="p-4 border-t">
              {{ periode.tahun_anggaran }}
            </td>
            <td v-if="can('write periode beasiswa')" class="w-px p-4 border-t">
              <Link class="rounded-l btn-indigo-sm" :href="`/accountability-periodes/${periode.id}/edit`">
                <font-awesome-icon icon="fas fa-pencil" />
              </Link>
              <Link class="rounded-r btn-red-sm" @click.prevent="destroy(periode.id)">
                <font-awesome-icon icon="fas fa-trash" />
              </Link>
            </td>
          </tr>
          <tr v-if="accountabilityPeriodes.data.length === 0">
            <td class="px-6 py-4 border-t" :colspan="can('write periode pertanggungjawaban') ? 6 : 5">Tidak ada data periode pertanggungjawaban.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <pagination class="mt-6" :links="accountabilityPeriodes.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  components: {
    Head,
    Link,
    Pagination,
    FontAwesomeIcon,
  },

  layout: Layout,
  props: {
    accountabilityPeriodes: Object,
  },

  methods: {
    formatCurrency(value) {
      if (value === null || value === undefined) {
        return 'Rp 0'
      }
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value)
    },

    destroy(id) {
      this.$swal.fire({
        title: 'Anda yakin ingin menghapus data ini?',
        text: 'Data yang sudah dihapus tidak dapat dikembalikan!',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya, Hapus!',
        cancelButtonText: 'Batal',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(`/accountability-periodes/${id}`, {
            onSuccess: () => {
              this.$swal.fire(
                'Dihapus!',
                'Data berhasil dihapus.',
                'success',
              )
            },
            onError: () => {
              this.$swal.fire(
                'Gagal!',
                'Terjadi kesalahan saat menghapus data.',
                'error',
              )
            },
          })
        }
      })
    },
  },
}
</script>
